var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('packages-list-loader'):(_vm.errorMessage)?_c('gl-alert',{attrs:{"variant":"danger","dismissible":false}},[_vm._v("\n  "+_vm._s(_vm.errorMessage)+"\n")]):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }